<template>
  <div class="tabs-item">
    <div class="toolbar-row">
      <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
    </div>

    <el-table
      ref="table"
      border
      :data="tableData"
      :max-height="maxHeight"
      highlight-current-row
      v-loading="loading"
      @sort-change="handleSortChange"
    >
      <el-table-column
        v-for="item in columnData"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.width"
        :sortable="item.sortable ? 'custom' : false"
        :align="item.align"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <template v-if="['平台单号', '电商单号', '顾客ID', '店铺名称', '商品编码', '商品名称'].includes(item.label)">
            <remark :content="scope.row[item.prop]"></remark>
          </template>
          <template v-else>
            {{ scope.row[item.prop] }}
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="footer-row">
      <div class="refresh-time">
        <span>{{ timeText.updateContent ? '数据刷新时间：' : '' }}</span>
        <span>{{ timeText.latestUpdateTime || '' }}</span>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationOpt.pageNum"
        :page-sizes="paginationOpt.pageSizes"
        :page-size="paginationOpt.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationOpt.total"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperationAnalysisNonStockOrders',
  props: ['data', 'timeText'],
  data () {
    return {
      tableData: [],
      loading: false,
      orderParams: {},
      paginationOpt: {
        pageSizes: [30, 100, 500, 1000],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      columnData: [
        { label: '平台单号', prop: 'pcode', width: 150, align: 'left' },
        { label: '电商单号', prop: 'orderNo', width: 150, align: 'left' },
        { label: '顾客ID', prop: 'buyer', width: 120, align: 'left' },
        { label: '店铺名称', prop: 'storeName', width: 150, align: 'left' },
        { label: '是否国补', prop: 'isStateSubsidies', width: 100, align: 'center' },
        { label: '是否冻结', prop: 'frozenFlag', width: 100, align: 'center' },
        { label: '是否7天发货', prop: 'sevenDayFlag', width: 120, align: 'center' },
        { label: '服务商', prop: 'serviceName', width: 120, align: 'left' },
        { label: '办事处', prop: 'agencyName', width: 120, align: 'left' },
        { label: '付款日期', prop: 'payTime', width: 150, sortable: true, align: 'center' },
        { label: '审核日期', prop: 'auditTime', width: 150, sortable: true, align: 'center' },
        { label: '订单最晚发货时间', prop: 'latestShippingTime', width: 170, align: 'center' },
        { label: '交货周期（天）', prop: 'deliveryCycle', width: 120, sortable: true, align: 'right' },
        { label: '剩余发货时间', prop: 'lastDays', width: 130, sortable: true, align: 'right' },
        { label: '商品编码', prop: 'goodsCode', width: 130, align: 'left' },
        { label: '商品名称', prop: 'goodsName', width: 180, align: 'left' },
        { label: '购买数量', prop: 'buyNum', width: 100, align: 'right' },
        { label: '采购订单号', prop: 'purchaseOrderNo', width: 150, align: 'right' },
      ]
    }
  },
  computed: {
    formData () {
      return this.data
    },
    maxHeight () {
      const winH = document.documentElement.clientHeight
      return `${winH - 404}px`
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    buildFilterData () {
      return {
        ...this.formData,
        ...this.orderParams,
        outStockOrder: false
      }
    },
    search () {
      this.paginationOpt.pageNum = 1
      this.init()
    },
    init () {
      this.loading = true
      const data = {
        filterData: this.buildFilterData(),
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize
      }
      this.$q.orderDate.deliveryNonStockOutOrderList({ data }).then((res) => {
        if (res.success && res.data) {
          this.tableData = res.data.records || []
          this.paginationOpt = {
            ...this.paginationOpt,
            total: res.data.total || 0,
            pageNum: res.data.pageNum || 1
          }
        } else {
          this.tableData = []
          this.paginationOpt = { ...this.paginationOpt, total: 0 }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSortChange ({ prop, order }) {
      const fieldsName = {
        payTime: 'sortPayTime',
        auditTime: 'sortOfAuditTime',
        deliveryCycle: 'sortOrderDeliveryCycle',
        lastDays: 'sortOfDeliveryTime'
      }
      const orderType = { ascending: 'ASC', descending: 'DESC' }
      this.orderParams = {}
      if (fieldsName[prop] && orderType[order]) {
        this.orderParams[fieldsName[prop]] = orderType[order]
      }
      this.paginationOpt.pageNum = 1
      this.init()
    },
    handleSizeChange (val) {
      this.paginationOpt.pageSize = val
      this.paginationOpt.pageNum = 1
      this.init()
    },
    handleCurrentChange (val) {
      this.paginationOpt.pageNum = val
      this.init()
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = {
        taskDTO: {
          appCode: 'ec-pc-new',
          paramMap: {
            ...this.buildFilterData(),
            exportTag: true
          },
          reportName: 'nonStockOutOrderListExport'
        },
        columnDTOs: this.columnData.map(item => ({
          columnName: item.label,
          parentColumnName: null,
          fieldName: item.prop,
          fieldType: 'string',
          columnFormat: null
        }))
      }
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查询')
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.tabs-item
  height 100%

.toolbar-row
  display flex
  justify-content flex-end
  gap 8px
  margin-bottom 10px

.footer-row
  display flex
  justify-content space-between
  align-items center
  margin 10px 0

.refresh-time
  color #555

@media (max-width: 1200px)
  .footer-row
    flex-direction column
    align-items stretch
</style>
